export default "__VITE_ASSET__CCApvxDs__"